import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import $rate from "@/mixins/rate";
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";
import { FavoriteService, UserService } from "@/services";
import Price from "@/components/OrderPage/Price";
import truncate from "@/filters/truncate";

export default {
  name: "prices-table",
  components: { Price },
  filters: {
    truncate
  },
  props: {
    showAnimation: {
      type: Boolean
    },
    tableHeight: {
      type: Number
    }
  },
  mixins: [$rate, $exponent, $thousandMask],
  data() {
    return {
      selectedFilter: 0,
      favoriteList: [],
      pricesTableLoader: true,
      defaultCurrency: {
        id: 2,
        name: "Bitcoin",
        name_locale: "بیت‌کوین",
        iso: "BTC",
        symbol: "BTC",
        subunit: "Satoshi",
        exponent: 8,
        is_prepaid: false,
        has_extra: false,
        extra_name: null,
        logo_main:
          "http://dev-ex.ernyka.com/assets/icons/v4/currencies/BTC.svg",
        price: 37053,
        sell_price: 35941.41,
        buy_price: 37053,
        change_price: 37275.31,
        change_fee: 0.2,
        from_change_fee: 0.2,
        to_change_fee: 0.2,
        is_percent_change_fee: true,
        transfer_fee: 0.0004,
        is_percent_transfer_fee: false,
        networks: [
          {
            id: 1,
            name: "BITCOIN",
            regex:
              "^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^(bc1)[0-9A-Za-z]{39,59}$",
            transfer_fee: "0.000400000000000",
            is_percent_transfer_fee: false,
            is_deposit_active: true,
            is_withdraw_active: true
          }
        ],
        price_status: "static"
      },
      tab: null,
      test: [],
      selectedTab: 3,
      search: "",
      select: "جدیدترین",
      items: ["جدیدترین", "ارزان ترین", "گران ترین"],
      selected: [],
      checkbox: true,
      currencyTabs: [
        {
          title: "همه ارزها",
          id: 1
        },
        {
          title: "علاقمندی ها",
          id: 2
        }
      ],
      arrowTopImage: require("../../../assets/image/up.svg"),
      arrowDownImage: require("../../../assets/image/down.svg"),
      selectedCategory: "",
      selectedRow: 0,
      // fromPrice: 0,
      // toPrice: 0,
      toCurrency: 0,
      getToCurrency: true,
      lastFromCurrency: ""
    };
  },
  computed: {
    ...mapGetters({
      getBaseCurrencies: types.market.getters.GET_BASE_CURRENCIES_DATA,
      currenciesData: types.currencies.getters.GET_CURRENCIES,
      getFilteredMarketData: types.market.getters.GET_FILTERED_MARKET_LIST,
      getSelectedBaseCurrency: types.market.getters.GET_SELECTED_BASE_CURRENCY,
      getAllAvailableMarket: types.market.getters.GET_AVAILABLE_MARKET_DATA,
      wallets: types.wallets.getters.GET_WALLETS,
      buySellState: types.buySellState.getters.GET_BUY_SELL_STATE,
      getSelectedToCurrency: types.market.getters.GET_TO_CURRENCY,
      getSelectedToDefaultCurrency:
        types.market.getters.GET_DEFAULT_TO_CURRENCY,
      defaultAsset: types.market.getters.GET_DEFAULT_TO_CURRENCY,
      baseId: types.market.getters.GET_SELECTED_BASE_CURRENCY,
      asset: types.market.getters.GET_TO_CURRENCY,
      userSetting: types.userSetting.getters.GET_USER_SETTING,
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),
    // currenciesList() {
    //   return [...this.currenciesData];
    // },
    tableHeader() {
      const currency = this.getBaseCurrencies.find(el => el.id === this.baseId);
      this.$t("orderPage.pricesTable.tableHeader")[1][`text`] = this.$t(
        "orderPage.pricesTable.baseCurrencyPrice",
        {
          iso: currency.iso
        }
      );

      return this.$t("orderPage.pricesTable.tableHeader");
    },
    fromCurrency() {
      if (this.currenciesData.length !== 0) {
        this.pricesTableLoader = false;
        return this.currenciesData.find(
          elem => elem.id === this.getSelectedBaseCurrency
        );
      }
    },
    currenciesRate() {
      let data = [...this.currenciesData];
      data.forEach(elem => {
        const rate = this.$rate(this.fromCurrency, elem, this.buySellState);
        const expo = this.$exponent(rate, this.baseExponent);
        elem.sell_rate_price = expo;
      });
      return data;
    },
    filteredMarketData: {
      get() {
        return this.getAllAvailableMarket
          .filter(elem => {
            return (
              elem.base_currency_id === this.getSelectedBaseCurrency &&
              elem.is_enable
            );
          })
          .map(item => item.asset_currency_id);
      },
      set(newValue) {
        this.setFilteredMarketList(newValue);
      }
    },
    filteredCurrenciesData() {
      if (this.currenciesRate) {
        let currencies = [...this.currenciesRate];
        currencies = currencies.filter(elem =>
          this.filteredMarketData.includes(elem.id)
        );
        if (currencies.length !== 0) {
          if (Object.entries(this.getSelectedToCurrency).length !== 0) {
            let data = currencies.find(
              elem => elem.id === this.getSelectedToCurrency.id
            );
            if (data) {
              this.selectCurrency(data);
            } else {
              this.selectCurrency(currencies[0]);
            }
          } else if (Object.entries(this.getSelectedToCurrency).length === 0) {
            this.setDefaultToCurrency(currencies[0]).then(() => {
              // if (!this.getToCurrency) {
              this.selectCurrency(currencies[0]);
              // }
              // if (this.fromCurrency.id !== this.lastFromCurrency) {
              //   this.selectCurrency(currencies[0]);
              //   this.lastFromCurrency = this.getSelectedBaseCurrency;
              // }
            });
          }
          // this.getToCurrency = true;
        }
        return currencies;
      }
    },
    filterResult() {
      if (this.selectedTab === 1) {
        return this.newTableData.filter(elem => {
          return (
            elem.name_locale
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.name
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.iso
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, ""))
          );
        });
      } else if (this.selectedTab === 2) {
        let wallet = [];
        this.wallets.wallets.forEach(elem => {
          this.newTableData.find(data => {
            if (elem.balance > 0) {
              if (elem.iso === data.iso) {
                wallet.push(data);
              }
            }
          });
        });
        if (this.search) {
          return wallet.filter(elem => {
            return (
              elem.name_locale
                .replace(/[^\p{L}]/gu, "")
                .toLowerCase()
                .includes(
                  this.search.toLowerCase().replace(/[^\p{L}]/gu, "")
                ) ||
              elem.name
                .replace(/[^\p{L}]/gu, "")
                .toLowerCase()
                .includes(
                  this.search.toLowerCase().replace(/[^\p{L}]/gu, "")
                ) ||
              elem.iso
                .replace(/[^\p{L}]/gu, "")
                .toLowerCase()
                .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, ""))
            );
          });
        } else {
          switch (this.selectedCategory) {
            // case this.$t("pricesPage.categoriesMenu[0]"):
            //   dataArr.sort((a, b) => parseFloat(a.rank) - parseFloat(b.rank));
            //   break;
            case this.$t("orderPage.categoriesMenu[0]"):
              wallet.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
              break;
            case this.$t("orderPage.categoriesMenu[1]"):
              wallet.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
              break;
          }
          return wallet;
        }
      } else if (this.selectedTab === 3) {
        if (this.favoriteList.length !== 0) {
          return this.newTableData.filter(elem => {
            if (this.favoriteList.find(el => el.id === elem.id)) {
              return (
                elem.name_locale
                  .replace(/[^\p{L}]/gu, "")
                  .toLowerCase()
                  .includes(
                    this.search.toLowerCase().replace(/[^\p{L}]/gu, "")
                  ) ||
                elem.name
                  .replace(/[^\p{L}]/gu, "")
                  .toLowerCase()
                  .includes(
                    this.search.toLowerCase().replace(/[^\p{L}]/gu, "")
                  ) ||
                elem.iso
                  .replace(/[^\p{L}]/gu, "")
                  .toLowerCase()
                  .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, ""))
              );
            }
          });
        }
      }
    },
    newTableData() {
      let dataArr = [...this.filteredCurrenciesData];
      switch (this.selectedCategory) {
        // case this.$t("pricesPage.categoriesMenu[0]"):
        //   dataArr.sort((a, b) => parseFloat(a.rank) - parseFloat(b.rank));
        //   break;
        case this.$t("orderPage.categoriesMenu[0]"):
          dataArr.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
          break;
        case this.$t("orderPage.categoriesMenu[1]"):
          dataArr.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
          break;
      }
      return dataArr;
    }
  },
  watch: {
    filteredMarketData(newValue) {
      this.setFilteredMarketList(newValue);
    },
    search(newValue) {
      if (newValue === null) {
        this.search = "";
      }
    }
  },
  mounted() {
    this.findBaseCurrencyFromUserSetting();
    // FOR DEVELOPMENT
    // this.setToCurrency(this.defaultCurrency);
    this.getFave();
  },
  methods: {
    ...mapActions({
      setToCurrency: types.market.actions.SET_TO_CURRENCY,
      setDefaultToCurrency: types.market.actions.SET_DEFAULT_TO_CURRENCY,
      setFilteredMarketList: types.market.actions.SET_FILTERED_MARKET_LIST,
      setSelectedBaseCurrency: types.market.actions.SET_SELECTED_BASE_CURRENCY,
      setUserSetting: types.userSetting.actions.SET_USER_SETTING
    }),
    findBaseCurrencyFromUserSetting() {
      const currencies = this.getBaseCurrencies;
      const { is_global } = this.userInfo;
      const { base_currency } = this.userSetting.order;

      const USDT = currencies.find(c => c.iso === "USDT");
      const IRR = currencies.find(c => c.iso === "IRR");

      if (is_global && USDT) {
        return this.setSelectedBaseCurrency(USDT.id);
      }

      if (!is_global && IRR) {
        return this.setSelectedBaseCurrency(IRR.id);
      }

      const userCurrency = currencies.find(c => c.iso === base_currency);
      if (userCurrency) {
        return this.setSelectedBaseCurrency(userCurrency.id);
      }

      if (currencies.length > 0) {
        this.setSelectedBaseCurrency(currencies[0].id);
      }
    },
    filterMarketList(currency) {
      this.setBaseCurrencyInUserSetting(currency.iso);
      this.setSelectedBaseCurrency(currency.id);
    },
    setBaseCurrencyInUserSetting(currency) {
      let data = this.userSetting;
      data.order.base_currency = currency;
      UserService.setSetting(data).then(res => {
        this.setUserSetting(res.data.data);
      });
    },
    setSelectedClass(item) {
      return item.id === this.selectedRow ? "selected-table-row" : "";
    },
    selectCurrency(currency) {
      this.getToCurrency = false;
      this.selectedRow = currency.id;
      this.setToCurrency(currency);
    },
    changeTableData(category) {
      this.selectedCategory = category;
      return this.newTableData;
    },
    getFave() {
      FavoriteService.getFavoritesCurrencies()
        .then(res => {
          this.favoriteList = res.data.data;
        })
        .then(() => {
          this.changeTabs();
        })
        .then(() => {
          this.changeTabs();
        });
    },
    changeTabs() {
      if (this.favoriteList.length === 0) {
        this.tab = 1;
        this.selectedTab = 2;
      }
      if (this.filterResult.length === 0) {
        this.tab = 2;
        this.selectedTab = 1;
      }
    },
    addToFav(item) {
      if (this.favoriteList.find(el => el.id === item.id)) {
        FavoriteService.removeFavoritesCurrencies(item.id)
          .then(res => {
            this.$toast.success(res.data.message);
          })
          .then(() => {
            this.getFave();
          });
      } else {
        FavoriteService.addFavoritesCurrencies(item.id)
          .then(res => {
            this.$toast.success(res.data.message);
          })
          .then(() => {
            this.getFave();
          });
      }
    }
  }
};
